import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
} from 'reactstrap';
import { Link } from 'react-router-dom';


const Content = ({
  title, breads, children, tablet, onClick, category, language, theme, text,
}) => (
  <Container>
      <Wrapper>
        {
          breads && (
            <Breadcrumb>
              {
                breads.map((bread, index) => {
                  const key = `bread-${index}`;
                  return (
                    <BreadcrumbItem active={!!bread.to} key={key}>
                      {' '}
                      {bread.to ? <Link to={bread.to}>{bread.name}</Link> : bread.name}
                      {' '}
                    </BreadcrumbItem>
                  );
                })
              }
            </Breadcrumb>
          )
        }
        <FormTitleWrapper>
          <FormTitle>{title}</FormTitle>
          {((tablet || category || language || theme) && onClick) && (
            <div>
              <Button color="danger" onClick={onClick}>
                {text}
              </Button>
            </div>
          )}
        </FormTitleWrapper>
        <ContentWrapper>
          {children}
        </ContentWrapper>
      </Wrapper>
    </Container>
);

Content.defaultProps = {
  breads: null,
};

Content.propTypes = {
  breads: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

const Container = styled.div`
  width: calc(100% - 250px);
  margin-left: 250px;
  border-collapse: separate; 
  box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.05); 
  padding: 20px 20px 10px 20px;
  position: relative;
  @media (min-width: 320px) and (max-width: 480px) {
    padding: 10px;
  }
`;
const Wrapper = styled.div`
  position: relative;
`;
const FormTitleWrapper = styled.div`
  padding: 10px;
  border-bottom: 1px solid #ebedf2;
  min-height: 60px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 25px;
  background-color: #fff;
`;
const FormTitle = styled.h3`
  margin: 0;
  padding: 0;
  font-size: 1.2rem;
  font-weight: 500;
  color: #464457;
`;
const ContentWrapper = styled.div`
  padding: 15px;
  background-color: #fff;
`;
function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert,
  };
}
export default connect(mapStateToProps)(Content);
